import React, { useEffect, useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import DeleteModal from "../../modals/DeleteModal";
import { NotificationSidebar } from "../../subcomponents/notification/Sidebar";
import { IFlatNotification } from "../../../types/notification";
import useUpdateNotification from "../../../hooks/notification/useUpdateNotification";
import useCreateNotification from "../../../hooks/notification/useCreateNotification";
import useDeleteNotification from "../../../hooks/notification/useDeleteNotification";
import useGetNotifications from "../../../hooks/notification/useGetNotification";
import useSendNotification from "../../../hooks/notification/useSendNotification";
import { ToastContainer } from "react-toastify";
import Modal from "../../modals/Modal";
import useGetActions from "../../../hooks/action/useGetActions";
import useCreateAction from "../../../hooks/action/useCreateAction";
import useUpdateAction from "../../../hooks/action/useUpdateAction";
import useDeleteAction from "../../../hooks/action/useDeleteAction";
import { IAction } from "../../../types/action";
import Action from "../../subcomponents/notification/actions/Action";
import Notification from "../../subcomponents/notification/Notification";

const Notifications = () => {
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isOpenSendModal, setIsOpenSendModal] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [isAddAction, setIsAddAction] = useState(false);
  const [isAddNotification, setIsAddNotification] = useState(false);
  const [isActionOpen, setIsActionOpen] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [currentOption, setCurrentOption] = useState<number[]>([]);
  const [isProcessRunning, setIsProcessRunning] = useState<boolean>(false);
  const [, setIsServiceError] = useState<string | null>(null);
  const [deleteModalMessage, setDeleteModalMessage] = useState<{ title: string; subtitle: string }>({ title: "", subtitle: "" });

  const { data: actions, isLoading: isActionLoading, isError: isActionError } = useGetActions();
  const { data: notifications, isLoading: isNotificationLoading, isError: isNotificationError } = useGetNotifications();

  const { mutate: createAction } = useCreateAction({ setIsProcessRunning, setIsServiceError });
  const { mutate: updateAction } = useUpdateAction({ setIsProcessRunning, setIsServiceError });
  const { mutate: deleteAction } = useDeleteAction({ setIsProcessRunning, setIsServiceError });

  const { mutate: createNotification } = useCreateNotification({ setIsProcessRunning, setIsServiceError });
  const { mutate: updateNotification } = useUpdateNotification({ setIsProcessRunning, setIsServiceError });
  const { mutate: deleteNotification } = useDeleteNotification({ setIsProcessRunning, setIsServiceError });
  const { mutate: sendNotification } = useSendNotification({ setIsProcessRunning, setIsServiceError });

  const handleSendNotification = () => {
    setIsOpenSendModal(true);
  };

  const handleAddAction = () => {
    setIsAddAction(true);
    setIsActionOpen(true);
    setCurrentOption([]);
  };

  const handleAddNotification = () => {
    setIsAddNotification(true);
    setIsNotificationOpen(true);
    setCurrentOption([]);
  };

  const handleActionAccordion = () => {
    setCurrentOption([0]);

    if (isActionOpen) {
      setIsActionOpen(false);
    }

    setIsActionOpen(!isActionOpen);
  };

  const handleNotificationAccordion = () => {
    setCurrentOption([1]);

    if (isNotificationOpen) {
      setIsNotificationOpen(false);
    }

    setIsNotificationOpen(!isNotificationOpen);
  };

  const handleSaveAction = (e: React.FormEvent<HTMLFormElement>, action: IAction) => {
    if (e) e.preventDefault();

    if (isAddAction) {
      createAction(action);

    } else {
      updateAction(action);
    }
  }

  const handleDeleteAction = (id?: number) => {
    if (isAddAction || !id) {
      setIsAddAction(false);
      if (actions && actions.length > 0) setCurrentOption([0, actions.length - 1]);
      else setCurrentOption([0]);
    }
    else {
      setDeleteModalMessage({ title: "Are you sure?", subtitle: "You can not recover the deleted action." });
      setIsOpenDeleteModal(true);
    }
  }

  const handleSaveNotification = (e: React.FormEvent<HTMLFormElement>, notification: IFlatNotification) => {
    if (e) e.preventDefault();

    if (isAddNotification) {
      createNotification(notification);

    } else {
      updateNotification(notification);
    }
  }

  const handleDeleteNotification = (id?: number) => {
    if (isAddNotification || !id) {
      setIsAddNotification(false);
      if (notifications && notifications.length > 0) setCurrentOption([1, notifications.length - 1]);
      else setCurrentOption([1]);
    }
    else {
      setDeleteModalMessage({ title: "Are you sure?", subtitle: "You can not recover the deleted notification." });
      setIsOpenDeleteModal(true);
    }
  }

  useEffect(() => {
    if (isDelete && actions && currentOption.length === 2 && currentOption[0] === 0) {
      deleteAction(actions[currentOption[1]].id || 0);
      if (actions && actions.length > 0 && currentOption[1] > 0) setCurrentOption([0, currentOption[1] - 1]);
      else setCurrentOption([0]);
    }

    if (isDelete && notifications && currentOption.length === 2 && currentOption[0] === 1) {
      deleteNotification(notifications[currentOption[1]].id || 0);
      if (notifications && notifications.length > 0 && currentOption[1] > 0) setCurrentOption([1, currentOption[1] - 1]);
      else setCurrentOption([1]);
    }

    setIsDelete(false);
  }, [isDelete]); // eslint-disable-line

  useEffect(() => {
    if (isSent && notifications) {
      sendNotification(notifications[currentOption[1]].id || 0);
    }
    setIsSent(false);
  }, [isSent]); // eslint-disable-line


  useEffect(() => {
    if (actions) {
      if (isAddAction) {
        if (actions) setCurrentOption([0, actions.length - 1])
        setIsAddAction(false);
      }
    }
    if (notifications) {
      if (isAddNotification) {
        if (notifications) setCurrentOption([1, notifications.length - 1])
        setIsAddNotification(false);
      }
    }
  }, [actions, notifications]); // eslint-disable-line

  useEffect(() => {
    if (isAddAction) {
      if (currentOption.length > 0) {
        setIsAddAction(false);
      }
    }

    if (isAddNotification) {
      if (currentOption.length > 0) {
        setIsAddNotification(false);
      }
    }
  }, [currentOption, isAddAction, isAddNotification]); // eslint-disable-line

  if (isActionLoading || isNotificationLoading) {
    return <div>Loading...</div>;
  }

  if (isActionError || isNotificationError) {
    return <div>Error...</div>;
  }

  if (actions === undefined || notifications === undefined) {
    return <div>Empty...</div>;
  }

  return (<>
    {isOpenDeleteModal && (
      <DeleteModal
        setIsOpenDeleteModal={setIsOpenDeleteModal}
        setIsDelete={setIsDelete}
        title={deleteModalMessage.title}
        subtitle={deleteModalMessage.subtitle}
      />
    )}
    {isOpenSendModal && (
      <Modal
        setIsOpenModal={setIsOpenSendModal}
        setIsAction={setIsSent}
        title="Do you want to send?"
        subtitle="You can not update/delete the notification once sent"
      />
    )}
    <MainLayout>
      <div className="imm_admin__main_view">
        <NotificationSidebar
          handleActionAccordion={handleActionAccordion}
          handleNotificationAccordion={handleNotificationAccordion}
          handleAddAction={handleAddAction}
          handleAddNotification={handleAddNotification}
          isActionOpen={isActionOpen}
          isNotificationOpen={isNotificationOpen}
          isAddAction={isAddAction}
          isAddNotification={isAddNotification}
          currentOption={currentOption}
          setCurrentOption={setCurrentOption}
          actions={actions}
          notifications={notifications}
        />
        <div className="imm_admin__main_content">
          {((currentOption.length === 2 && currentOption[0] === 0) || isAddAction) && <Action handleSaveAction={handleSaveAction} handleDeleteAction={handleDeleteAction} isAddAction={isAddAction} isDelete={isDelete} setIsDelete={setIsOpenDeleteModal} currentOption={currentOption} setCurrentOption={setCurrentOption} isProcessRunning={isProcessRunning} actions={actions} />}
          {((currentOption.length === 2 && currentOption[0] === 1) || isAddNotification) && <Notification handleSaveNotification={handleSaveNotification} handleDeleteNotification={handleDeleteNotification} handleSendNotification={handleSendNotification} isAddNotification={isAddNotification} isDelete={isDelete} setIsDelete={setIsOpenDeleteModal} currentOption={currentOption} setCurrentOption={setCurrentOption} isProcessRunning={isProcessRunning} notifications={notifications} actions={actions} />}
          {currentOption.length === 1 && currentOption[0] === 0 && (<div className="imm_admin__main_content__empty"><h4>{actions.length === 0 ? 'Please create an action' : 'Please select an action'}</h4></div>)}
          {currentOption.length === 1 && currentOption[0] === 1 && (<div className="imm_admin__main_content__empty"><h4>{notifications.length === 0 ? 'Please create a notification' : 'Please select a notification'}</h4></div>)}
        </div>
      </div>
      <ToastContainer autoClose={2000} />
    </MainLayout>
  </>
  );
};

export default Notifications;
